import { useEffect } from "react";

import { Banner } from "@chef/components";
import { FEATURE_FLAGS, PAYMENT_PARTNER_IDS } from "@chef/constants";
import {
  closeModal,
  openModal,
  selectModalIsOpen,
  useBillingQuery,
} from "@chef/state-management";
import { useIntercom, usePersistentState } from "@chef/hooks";
import { noop } from "@chef/utils/noop";
import {
  useAppDispatch,
  useAppSelector,
  usePaymentSession,
} from "@chef/state-management/hooks";
import { isEqualStrings } from "@chef/utils/equal";
import { useFlag } from "@chef/feature-flags";

export const OldVippsBanner = () => {
  const dispatch = useAppDispatch();
  const isRenewVippsAgreementModalOpen = useAppSelector(
    selectModalIsOpen("RENEW_VIPPS_AGREEMENT"),
  );
  const { enabled: isPopupEnabled } = useFlag(
    FEATURE_FLAGS.VIPPS_POPUP_ENABLED,
  );

  const { data: billingQuery } = useBillingQuery();

  const { createSession } = usePaymentSession();

  const [isOpen] = usePersistentState("old_vipps_popup_open", true, {
    mode: "session",
  });

  const { showBubble, hideBubble } = useIntercom(!isOpen);

  useEffect(() => {
    if (isOpen) {
      hideBubble();

      return () => {
        showBubble();
      };
    } else {
      return noop;
    }
  }, [isOpen, showBubble, hideBubble]);

  const paymentPartnerId = billingQuery?.billing.paymentPartnerId;
  const currentPaymentCardTokenType =
    billingQuery?.billing?.currentPaymentCard?.tokenType;

  const isOldVipps =
    isEqualStrings(paymentPartnerId, PAYMENT_PARTNER_IDS.ADYEN) &&
    isEqualStrings(currentPaymentCardTokenType, "vipps");

  useEffect(() => {
    if (isOpen && isOldVipps && isPopupEnabled) {
      dispatch(openModal({ id: "RENEW_VIPPS_AGREEMENT" }));
    } else {
      if (isRenewVippsAgreementModalOpen) {
        dispatch(closeModal());
      }
    }
  }, [
    isOpen,
    isOldVipps,
    isPopupEnabled,
    dispatch,
    isRenewVippsAgreementModalOpen,
  ]);

  if (!billingQuery || !isOldVipps) {
    return null;
  }

  return (
    <Banner onClick={createSession} highlighted>
      <span className="mr-2">Vipps-avtalen løper snart ut.</span>
      <span className="underline">
        <strong>Forny</strong>
      </span>
    </Banner>
  );
};
